<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">
      <template slot="actions">
        <vs-button color="primary" type="border" size="small" class="mr-2" @click="viewExample">{{ $t('view_example') }}</vs-button>
        <vs-button color="danger" type="filled" size="small" class="mr-2" @click="applyConfig" v-if="amportal">{{ $t('apply_config') }}</vs-button>
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addTimeConditionPopup">{{ $t('add') }}</vs-button>
      </template>

      <vs-divider></vs-divider>
    </vx-card>

    <vx-card id="timeConditionsDataContainer" :removeTitle="true" title=" " class="mb-8 vs-con-loading__container" v-if="activeTab == 1">

      <template slot="actions">
        <vs-button
          color="success"
          type="filled"
          class="mr-2"
          @click="activeTab=1"
        >
          {{ $t('time_conditions') }}
        </vs-button>

        <vs-button
          color="success"
          type="border"
          class="mr-2"
          @click="activeTab=2"
          v-if="hasUploadFileTab"
        >
          {{ $t('time_conditions_upload_file_upload_file') }}
        </vs-button>

        <vs-button
          v-if="showKeyword"
          v-for="(keyword, key) in keywords" :key="key"
          color="primary"
          :type="activeKeyword == keyword.name ? 'filled' : 'border'"
          size="small"
          @click="changeKeyword(keyword.name)">
          {{ keyword.name }}
        </vs-button>
      </template>

      <div class="flex mb-4">
        <vs-button
          color="success"
          :type="`${timeGroup['value'] == activeType ? 'filled' : 'border'}`"
          size="small"
          class="mr-2"
          v-for="(timeGroup, key) in timeGroups" :key="key"
          @click="changeType(timeGroup['value'])"
          v-text="`${ timeGroup['translate'] ? $t(timeGroup['translation']) : timeGroup['label']}`"
        >
        </vs-button>
      </div>

      <shared-time-conditions-list
        :timeConditions="timeConditions"
        @editTimeCondition="editTimeConditionPopup"
        @destroyTimeCondition="destroyTimeCondition"
      ></shared-time-conditions-list>

      <template slot="footer">
        <h5>※<span v-text="$t('cautions_on_setting_holiday')"></span></h5>
        <ol>
          <li class="text-danger" v-text="$t('you_must_press_the_run_button')"></li>
          <li v-text="$t('the_priority_is_in_the_order')"></li>
        </ol>
      </template>
    </vx-card>
    <vx-card id="timeConditionsDataContainer" :removeTitle="true" title=" " class="mb-8 vs-con-loading__container" v-if="activeTab == 2 && hasUploadFileTab">
      <template slot="actions">
        <vs-button
          color="success"
          type="border"
          class="mr-2"
          @click="activeTab=1"
        >
          {{ $t('time_conditions') }}
        </vs-button>
        <vs-button
          color="success"
          type="filled"
          class="mr-2"
          @click="activeTab=2"
        >
          {{ $t('time_conditions_upload_file_upload_file') }}
        </vs-button>
      </template>

      <shared-time-conditions-sound-file-list
        :timeGroups="timeGroups"
        @timeConditionSoundFile="timeConditionSoundFilePopup"
        @destroyTimeConditionSoundFile="destroyTimeConditionSoundFile"
      ></shared-time-conditions-sound-file-list>

      <template slot="footer">
        <h5 class="text-danger" v-text="$t('time_conditions_upload_file_cautions')" />
      </template>

    </vx-card>

    <modal :title="$t('add_time_conditions')" :active.sync="modals.add" size="md">
      <div id="AddTimeConditionFormContainer" class="vs-con-loading__container">

        <shared-time-conditions-add
          :activeKeyword="activeKeyword"
          :activeType="activeType"
          :hourOptions="hourOptions"
          :minuteOptions="minuteOptions"
          :weekDayOptions="weekDayOptions"
          :monthDayOptions="monthDayOptions"
          :monthOptions="monthOptions"
          @addTimeConditionSuccess="addTimeConditionSuccess"
        ></shared-time-conditions-add>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="addTimeConditionButton" color="primary" type="filled" @click.prevent="addTimeConditions">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

    <modal :title="$t('edit_time_conditions')" :active.sync="modals.edit" size="md">
      <div id="EditTimeConditionFormContainer" class="vs-con-loading__container">

        <shared-time-conditions-edit
          :activeKeyword="activeKeyword"
          :activeType="activeType"
          :hourOptions="hourOptions"
          :minuteOptions="minuteOptions"
          :weekDayOptions="weekDayOptions"
          :monthDayOptions="monthDayOptions"
          :monthOptions="monthOptions"
          @editTimeConditionSuccess="editTimeConditionSuccess"
        ></shared-time-conditions-edit>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="editTimeConditionButton" color="primary" type="filled" @click.prevent="updateTimeConditions">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import TimeCondition from '@/models/TimeCondition'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import SharedTimeConditionsList from '@/views/Shared/TimeConditions/List'
import SharedTimeConditionsAdd from '@/views/Shared/TimeConditions/Add'
import SharedTimeConditionsEdit from '@/views/Shared/TimeConditions/Edit'
import SharedTimeConditionsSoundFileList from '@/views/Shared/TimeConditions/SoundFile/List'

export default {
  name: 'User.TimeConditions',
  components: {
    Modal,
    SharedTimeConditionsList,
    SharedTimeConditionsAdd,
    SharedTimeConditionsEdit,
    SharedTimeConditionsSoundFileList
  },
  data () {
    return {
      timeConditions: [],
      timeGroups: [],
      amportal: false,
      hasUploadFileTab: false,
      activeKeyword: '',
      activeType: 'holiday',
      hourOptions: [],
      minuteOptions: [],
      weekDayOptions: [],
      monthOptions: [],
      monthDayOptions: [],
      showKeyword: false,
      modals: {
        add: false,
        edit: false
      },
      activeTab: 1
    }
  },
  watch: {
    'modals.edit' (val) {
      if (!val) {
        EventBus.$emit('initTimeConditionResetFormData')
      }
    },
    'modals.add' (val) {
      if (!val) {
        EventBus.$emit('initTimeConditionResetFormData')
      }
    }
  },
  mounted () {
    this.activeKeyword = this.keywords[0].name
    this.loadData()
    this.$windowOpenerHelper.listenToPopUpMessage('reload_time_conditions_table', this.loadData)
  },
  computed: {
    keywords () {
      return this.$store.getters.userInfo.company.keywords
    },
    hasKeyword () {
      return this.keywords.length > 0
    }
  },
  methods: {
    async loadData () {
      this.$vs.loading({container: '#timeConditionsDataContainer'})

      if (this.hasKeyword) {
        try {
          const response = await TimeCondition.findAll({ keyword: this.activeKeyword, type: this.activeType })
          this.timeConditions = response.data.data.timeConditions
          this.timeGroups = response.data.meta.timeGroups
          this.hourOptions = response.data.meta.options.hourOptions
          this.minuteOptions = response.data.meta.options.minuteOptions
          this.weekDayOptions = response.data.meta.options.weekDayOptions
          this.monthOptions = response.data.meta.options.monthOptions
          this.monthDayOptions = response.data.meta.options.monthDayOptions
          this.amportal = response.data.meta.amportal
          this.hasUploadFileTab = response.data.meta.hasUploadFileTab
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })

          if (e.response.status === 404 || e.response.code === 404) {
            // Reset to first keyword and default type
            this.activeKeyword = this.keywords[0].name
            this.activeType = 'holiday'
            this.loadData()
          }
        }
      } else {
        this.$swalHelper.error({
          title: 'Error!',
          text: 'Company Keyword is not set, please contact administrators.',
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#timeConditionsDataContainer > .con-vs-loading')
    },
    addTimeConditions () {
      EventBus.$emit('initSaveTimeCondition')
    },
    addTimeConditionModal () {
      this.modals.add = true
    },
    addTimeConditionPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-time-condition', {keyword: this.activeKeyword, type: this.activeType}, this.addTimeConditionModal)
    },
    addTimeConditionSuccess () {
      this.loadData()
      this.modals.add = false
    },
    updateTimeConditions () {
      EventBus.$emit('initUpdateTimeCondition')
    },
    editTimeConditionModal (data) {
      this.modals.edit = true
      EventBus.$emit('initTimeConditionGetFormData', {id: data.id})
    },
    editTimeConditionPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-time-condition', {id, keyword: this.activeKeyword, type: this.activeType}, this.editTimeConditionModal)
    },
    editTimeConditionSuccess () {
      this.loadData()
      this.modals.edit = false
    },
    timeConditionSoundFilePopup (index, list) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'time-condition-sound-file', {index, list})
    },
    async destroyTimeCondition (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await TimeCondition.destroy({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadData()
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    async destroyTimeConditionSoundFile (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await TimeCondition.destroySoundFile({ timeGroupIndex: id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadData()
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    applyConfig () {
      this.$store.dispatch('setIsMainTableLoading', true)
      try {
        const response = TimeCondition.apply()

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.loadData()
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
      this.$store.dispatch('setIsMainTableLoading', false)
    },
    viewExample () {
      window.open('/downloadables/시간설정_예제.pdf')
    },
    changeKeyword (keyword) {
      this.activeKeyword = keyword
      this.loadData()
    },
    changeType (type) {
      this.activeType = type
      this.loadData()
    },
    __getTranslatedValidationErrors (object) {
      const translatedErrors = {}

      for (const i in object) {
        translatedErrors[i] = [this.$t(object[i][0])]
      }

      return translatedErrors
    }
  }
}
</script>

<style scoped>

</style>
